// Modal defaults: overlayID "modal-overlay", dialog root id "modal".
// Drawer uses the same shape. Floating surfaces (ActionsMenu, Popover,
// DatePickerNext) read these so a control inside the dialog portals into
// the focus trap and stacks above the panel.
const MODAL_OVERLAY_ID = "modal-overlay";
const MODAL_ROOT_ID = "modal";
const DRAWER_OVERLAY_ID = "drawer-overlay";
const DRAWER_ROOT_ID = "drawer";

const STACKING_HOSTS = [
  { overlayId: MODAL_OVERLAY_ID, rootId: MODAL_ROOT_ID },
  { overlayId: DRAWER_OVERLAY_ID, rootId: DRAWER_ROOT_ID },
];

const stackingHostFor = (triggerRef) => {
  const trigger = triggerRef?.current;
  if (!trigger) {
    return null;
  }

  return (
    STACKING_HOSTS.find(({ overlayId }) => {
      const overlay = document.getElementById(overlayId);
      return overlay?.contains?.(trigger);
    }) ?? null
  );
};

const getFloatingUiZIndex = (triggerRef) => {
  return stackingHostFor(triggerRef) ? 1100 : 900;
};

const REACT_SELECT_MENU = "react-select-menu";

const getReactSelectMenu = (triggerRef) => {
  const selectWrapper = triggerRef?.current?.closest(
    '[data-select-wrapper="true"]'
  );

  if (selectWrapper) {
    return selectWrapper;
  }

  return document.getElementById(REACT_SELECT_MENU);
};

const isRenderedInReactSelectMenu = (triggerRef) => {
  return !!getReactSelectMenu(triggerRef);
};

const getFloatingUiRootElement = (triggerRef) => {
  const host = stackingHostFor(triggerRef);

  if (host) {
    return document.getElementById(host.rootId);
  }

  if (isRenderedInReactSelectMenu(triggerRef)) {
    const menu = getReactSelectMenu(triggerRef);
    if (menu?.contains(triggerRef?.current)) {
      return menu;
    }
  }

  return undefined;
};

export {
  DRAWER_OVERLAY_ID,
  DRAWER_ROOT_ID,
  getFloatingUiZIndex,
  getFloatingUiRootElement,
  isRenderedInReactSelectMenu,
};
